// ================================
// src/i18n.ts — FINAL (no errors)
// - 정적 import 방식 (네트워크 로드 X)
// - supportedLngs/returnNull/returnObjects 안전 설정
// - RTL(ar) 방향 자동 전환
// ================================
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

/* ───────── 한국어 ───────── */
import koSignal from "../locales/ko/signal.json";
import koSignalIntro from "../locales/ko/signalIntro.json";
import koLegal from "../locales/ko/legal.json";
import koCommon from "../locales/ko/common.json";

/* ───────── 영어 ───────── */
import enSignal from "../locales/en/signal.json";
import enSignalIntro from "../locales/en/signalIntro.json";
import enLegal from "../locales/en/legal.json";
import enCommon from "../locales/en/common.json";

/* ───────── 일본어 ───────── */
import jaSignal from "../locales/ja/signal.json";
import jaSignalIntro from "../locales/ja/signalIntro.json";
import jaLegal from "../locales/ja/legal.json";
import jaCommon from "../locales/ja/common.json";

/* ───────── 중국어 간체 ───────── */
import zhCnSignal from "../locales/zh-CN/signal.json";
import zhCnSignalIntro from "../locales/zh-CN/signalIntro.json";
import zhCnLegal from "../locales/zh-CN/legal.json";
import zhCnCommon from "../locales/zh-CN/common.json";

/* ───────── 중국어 번체 ───────── */
import zhTwSignal from "../locales/zh-TW/signal.json";
import zhTwSignalIntro from "../locales/zh-TW/signalIntro.json";
import zhTwLegal from "../locales/zh-TW/legal.json";
import zhTwCommon from "../locales/zh-TW/common.json";

/* ───────── 베트남어 ───────── */
import viSignal from "../locales/vi/signal.json";
import viSignalIntro from "../locales/vi/signalIntro.json";
import viLegal from "../locales/vi/legal.json";
import viCommon from "../locales/vi/common.json";

/* ───────── 힌디어 ───────── */
import hiSignal from "../locales/hi/signal.json";
import hiSignalIntro from "../locales/hi/signalIntro.json";
import hiLegal from "../locales/hi/legal.json";
import hiCommon from "../locales/hi/common.json";

/* ───────── 인도네시아어 ───────── */
import idSignal from "../locales/id/signal.json";
import idSignalIntro from "../locales/id/signalIntro.json";
import idLegal from "../locales/id/legal.json";
import idCommon from "../locales/id/common.json";

/* ───────── 태국어 ───────── */
import thSignal from "../locales/th/signal.json";
import thSignalIntro from "../locales/th/signalIntro.json";
import thLegal from "../locales/th/legal.json";
import thCommon from "../locales/th/common.json";

/* ───────── 스페인어 ───────── */
import esSignal from "../locales/es/signal.json";
import esSignalIntro from "../locales/es/signalIntro.json";
import esLegal from "../locales/es/legal.json";
import esCommon from "../locales/es/common.json";

/* ───────── 프랑스어 ───────── */
import frSignal from "../locales/fr/signal.json";
import frSignalIntro from "../locales/fr/signalIntro.json";
import frLegal from "../locales/fr/legal.json";
import frCommon from "../locales/fr/common.json";

/* ───────── 독일어 ───────── */
import deSignal from "../locales/de/signal.json";
import deSignalIntro from "../locales/de/signalIntro.json";
import deLegal from "../locales/de/legal.json";
import deCommon from "../locales/de/common.json";

/* ───────── 이탈리아어 ───────── */
import itSignal from "../locales/it/signal.json";
import itSignalIntro from "../locales/it/signalIntro.json";
import itLegal from "../locales/it/legal.json";
import itCommon from "../locales/it/common.json";

/* ───────── 포르투갈어 ───────── */
import ptSignal from "../locales/pt/signal.json";
import ptSignalIntro from "../locales/pt/signalIntro.json";
import ptLegal from "../locales/pt/legal.json";
import ptCommon from "../locales/pt/common.json";

/* ───────── 러시아어 ───────── */
import ruSignal from "../locales/ru/signal.json";
import ruSignalIntro from "../locales/ru/signalIntro.json";
import ruLegal from "../locales/ru/legal.json";
import ruCommon from "../locales/ru/common.json";

/* ───────── 아랍어 ───────── */
import arSignal from "../locales/ar/signal.json";
import arSignalIntro from "../locales/ar/signalIntro.json";
import arLegal from "../locales/ar/legal.json";
import arCommon from "../locales/ar/common.json";

/* ───────── 터키어 ───────── */
import trSignal from "../locales/tr/signal.json";
import trSignalIntro from "../locales/tr/signalIntro.json";
import trLegal from "../locales/tr/legal.json";
import trCommon from "../locales/tr/common.json";

/** 리소스 객체 (타입 안정) */
const resources = {
  ko: { signal: koSignal, signalIntro: koSignalIntro, legal: koLegal, common: koCommon },
  en: { signal: enSignal, signalIntro: enSignalIntro, legal: enLegal, common: enCommon },
  ja: { signal: jaSignal, signalIntro: jaSignalIntro, legal: jaLegal, common: jaCommon },
  "zh-CN": { signal: zhCnSignal, signalIntro: zhCnSignalIntro, legal: zhCnLegal, common: zhCnCommon },
  "zh-TW": { signal: zhTwSignal, signalIntro: zhTwSignalIntro, legal: zhTwLegal, common: zhTwCommon },
  vi: { signal: viSignal, signalIntro: viSignalIntro, legal: viLegal, common: viCommon },
  hi: { signal: hiSignal, signalIntro: hiSignalIntro, legal: hiLegal, common: hiCommon },
  id: { signal: idSignal, signalIntro: idSignalIntro, legal: idLegal, common: idCommon },
  th: { signal: thSignal, signalIntro: thSignalIntro, legal: thLegal, common: thCommon },
  es: { signal: esSignal, signalIntro: esSignalIntro, legal: esLegal, common: esCommon },
  fr: { signal: frSignal, signalIntro: frSignalIntro, legal: frLegal, common: frCommon },
  de: { signal: deSignal, signalIntro: deSignalIntro, legal: deLegal, common: deCommon },
  it: { signal: itSignal, signalIntro: itSignalIntro, legal: itLegal, common: itCommon },
  pt: { signal: ptSignal, signalIntro: ptSignalIntro, legal: ptLegal, common: ptCommon },
  ru: { signal: ruSignal, signalIntro: ruSignalIntro, legal: ruLegal, common: ruCommon },
  ar: { signal: arSignal, signalIntro: arSignalIntro, legal: arLegal, common: arCommon },
  tr: { signal: trSignal, signalIntro: trSignalIntro, legal: trLegal, common: trCommon },
} as const;

i18n.use(initReactI18next).init({
  resources,
  lng: "ko",                 // 초기 언어
  fallbackLng: "en",
  ns: ["signal", "signalIntro", "legal", "common"],
  defaultNS: "signal",

  returnObjects: false,      // 객체/배열을 문자열로 렌더하다 크래시 방지
  returnNull: false,         // 누락 키 null 방지(그대로 키가 노출되도록)

  interpolation: { escapeValue: false },
  supportedLngs: [
    "ko","en","ja","zh-CN","zh-TW","vi","hi","id","th",
    "es","fr","de","it","pt","ru","ar","tr",
  ],
});

/** RTL 언어 방향 자동 전환 */
const RTL = new Set(["ar"]);
i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") {
    document.dir = RTL.has(lng) ? "rtl" : "ltr";
  }
});

export default i18n;

/** 외부에서 언어 변경할 때 사용 */
export const setLang = (
  lng:
    | "ko" | "en" | "ja"
    | "zh-CN" | "zh-TW"
    | "vi" | "hi" | "id" | "th"
    | "es" | "fr" | "de" | "it" | "pt"
    | "ru" | "ar" | "tr"
) => i18n.changeLanguage(lng);
